import type { ReactElement } from 'react'

import type { MonetaryAmount } from '@twisto/api-graphql'
import { Amount } from '@twisto/components/atoms/amount'
import { Paper } from '@twisto/components/atoms/paper'
import { Typography } from '@twisto/components/atoms/typography'

import * as styles from './risk-approved-step-limit-paper.styles'

type Props = MonetaryAmount & {
  title: ReactElement
  subtitle: ReactElement
}

export const RiskApprovedStepLimitPaper = ({
  value,
  currency,
  title,
  subtitle,
}: Props) => (
  <Paper noMargin noPadding css={styles.paper}>
    <Amount
      amount={value}
      css={styles.amount}
      currency={currency}
      size="medium"
      title={title}
    />
    <Typography color="textTertiary" variant="b3">
      {subtitle}
    </Typography>
  </Paper>
)
